// The institute's own mark: its logo if it has uploaded one, otherwise a
// badge made from its initials. This is what makes the console feel like the
// institute's, not Prepgen's.

export function instituteInitials(name = '') {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (!words.length) return '?';
  if (words.length === 1) return words[0][0].toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
}

export default function InstituteMark({ org, size = 40, className = '' }) {
  const logoUrl = org?.metadata?.logoUrl;
  const style = { width: size, height: size, fontSize: Math.round(size * 0.38) };

  if (logoUrl) {
    return (
      <img
        src={logoUrl}
        alt={`${org?.name || 'Institute'} logo`}
        className={`institute-mark ${className}`}
        style={style}
      />
    );
  }

  return (
    <span className={`institute-mark institute-mark-initials ${className}`} style={style} aria-hidden="true">
      {instituteInitials(org?.name)}
    </span>
  );
}
